import { useCallback } from 'react'
import toast from 'react-hot-toast'
import { useLocalStorage } from 'usehooks-ts'

import { showApiError } from '@fv/client-core'

import { useCreateChatSession, useHasMoreUsage } from './api'
import { useChatPanel } from './ChatPanelProvider'

export const useChatSkipIntroPref = () => {
  return useLocalStorage<boolean>('fv-chat-skip-intro', false)
}

export const useStartChatSession = () => {
  const createChatSession = useCreateChatSession()
  const hasMoreUsage = useHasMoreUsage()
  const { openPanel, beginChatSession } = useChatPanel()

  const startChat = useCallback(
    async (message: string) => {
      const trimmed = message.trim()
      if (!trimmed || createChatSession.isPending) return

      openPanel()

      if (!hasMoreUsage) {
        toast.error('You have reached your limit for the month.')
        return
      }

      try {
        const result = await createChatSession.mutateAsync()
        beginChatSession(result._id, trimmed)
      } catch (error) {
        showApiError('Error starting chat', error)
      }
    },
    [beginChatSession, createChatSession, hasMoreUsage, openPanel],
  )
  return {
    startChat,
    isLoading: createChatSession.isPending,
  }
}
